import { Layout } from 'antd';
import styled from 'styled-components';

const BravoLayout = styled(Layout)`
  min-height: 100vh;
`;

export default BravoLayout;
